import React from "react";

import VeneerGrid from "veneer/Grid";
import styled from "veneer/styled";

import ApplicationCard from "cortex/ui/src/fleet/view/application/component/ApplicationCard";
import { Application } from "cortex/ui/src/fleet/view/application/model";
import { useAppSelector } from "cortex/ui/src/hooks";
import {
  applicationsSelector,
  applicationsStoresLoadedSelector,
  getPublicApps,
} from "cortex/ui/src/redux-store/applications/selectors";
import { makeGetAllAsArray } from "cortex/ui/src/redux-store/selectors";
import { Container } from "cortex/ui/src/view/layout/Container";

const getAllAppsAsArray = makeGetAllAsArray<Application>();

const Grid = styled(VeneerGrid)({
  display: "flex",
});

export default function ApplicationStoreList() {
  const appById = useAppSelector(applicationsSelector);
  const allApps = getAllAppsAsArray({ byId: appById });
  const apps = getPublicApps(allApps);
  const storesLoaded = useAppSelector(applicationsStoresLoadedSelector);

  return (
    <Container hideBox title="App Store">
      {storesLoaded && (
        <Grid container gap={2}>
          {apps.map((app, index) => (
            <Grid item key={index} width={196}>
              <ApplicationCard application={app} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}
